import React, { useEffect, useState } from 'react';
import './View.css';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Input, Card, Tooltip } from 'antd';
import { RiSearch2Line, RiAddFill, RiFolderFill } from 'react-icons/ri';
import Folder from './Folder/Folder';
import { useNavigate } from 'react-router-dom';
import { QuickActionFolderHandler } from '../../../Redux/Actions/user/QuickFolderAction';
import Loader from '../../../Components/Loader/Loader';
const lock_icon = '/assets/key-square.svg';
const View = ({ onOpen }) => {
    let dispatch = useDispatch();
    let Navigate = useNavigate();
    const BookMark = '/assets/bookmark.svg';
    const [isFolderOpen, setIsFolderOpen] = useState(false);
    const [isFolderId, setIsFolderId] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [isFolderName, setFolderName] = useState('');

    useEffect(() => {
        dispatch(QuickActionFolderHandler(searchValue, ''));
    }, []);
    const quickactionfolder = useSelector(
        (state) => state?.Quick_Action_Folder_Data?.quick_action_folder_data
    );
    const handleButtonClick = () => {
        Navigate('/build-quick-action');
    };
    // const handleButtonClick = () => { onOpen(); };
    const handleFolderClick = (id, folderName) => {
        setSearchValue('');
        dispatch(QuickActionFolderHandler('', ''));
        setIsFolderId(id);
        setIsFolderOpen(!isFolderOpen);
        setFolderName(folderName);
    };

    // const debounce = (func, delay) => {
    //     let timeoutId;
    //     return function (...args) {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //         timeoutId = setTimeout(() => {
    //             func.apply(this, args);
    //         }, delay);
    //     };
    // };
    const handlesearch = (e) => {
        let value = e.target.value.trim();
        if (value?.length) {
            setSearchValue(value);
        }

        if (value.length > 0) {
            setSearchValue(value);
            dispatch(QuickActionFolderHandler(value, ''));
        } else {
            setSearchValue('');
            dispatch(QuickActionFolderHandler('', ''));
        }
    };
    return (
        <>
            {isFolderOpen ? (
                <Folder
                    onOpenFolder={handleFolderClick}
                    folder_id={isFolderId}
                    folder_name={isFolderName}
                />
            ) : (
                <div className='build-main_2'>
                    <div className='build-tabel'>
                        <div className='build-mt-30'>
                            <div
                                className='build-red-tabel'
                                onClick={handleButtonClick}>
                                <div className='build-fair-pink'>
                                    <div className='build-your-own'>
                                        <RiAddFill className='build-img' />
                                    </div>
                                </div>
                                <div className='build-red-text'>
                                    <h5>Build Your Own</h5>
                                </div>
                            </div>
                            <div className='build-folder-title'>
                                <div className='build-folder-icon'>
                                    <RiFolderFill className='build-sideIcon-size' />
                                    <h4>QuickActions</h4>
                                </div>
                                <p>
                                    Explore our template library of prebuilt
                                    QuickActions
                                </p>
                            </div>
                            <div className='relative build-search-container'>
                                <Input
                                    placeholder='Search here...'
                                    prefix={<RiSearch2Line />}
                                    onChange={(e) => handlesearch(e)}
                                    value={searchValue}
                                />
                            </div>
                            <Row gutter={[16, 24]}>
                                {quickactionfolder?.data?.length > 0 ? (
                                    <>
                                        {quickactionfolder?.data &&
                                            quickactionfolder?.data.map(
                                                (item, index) => (
                                                    <Col
                                                        className='gutter-row'
                                                        span={6}
                                                        key={`quick-action-view-${index}`}>
                                                        <div
                                                            className='build-text'
                                                            onClick={() =>
                                                                handleFolderClick(
                                                                    item.id,
                                                                    item.name
                                                                )
                                                            }>
                                                            <div className='build-container-main'>
                                                                <div className='build-div-third'>
                                                                    <div className='build-top'></div>
                                                                    <div className='build-div-info'>
                                                                        {item?.logo_url ||
                                                                        item?.company_name ? (
                                                                            <>
                                                                                {item.logo_url ? (
                                                                                    <Tooltip
                                                                                        title={
                                                                                            item.company_name
                                                                                        }>
                                                                                        <img
                                                                                            src={
                                                                                                item.logo_url
                                                                                            }
                                                                                            className='logo_img'
                                                                                            alt='Company Logo'
                                                                                        />
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    <span className='logo_name'>
                                                                                        {
                                                                                            item.company_name
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        ) : null}
                                                                        {item?.is_restricted ===
                                                                            true && (
                                                                            <>
                                                                                <img
                                                                                    src={
                                                                                        lock_icon
                                                                                    }
                                                                                    className='lock_icon'
                                                                                />
                                                                            </>
                                                                        )}
                                                                        <h1 className='wrap-text'>
                                                                            <Tooltip
                                                                                title={
                                                                                    item.name
                                                                                }>
                                                                                {item
                                                                                    .name
                                                                                    .length >
                                                                                40
                                                                                    ? item.name.substring(
                                                                                          0,
                                                                                          40
                                                                                      ) +
                                                                                      '...'
                                                                                    : item.name}
                                                                            </Tooltip>
                                                                        </h1>
                                                                        <p>
                                                                            Total
                                                                            QuickActions
                                                                            <span>
                                                                                {' '}
                                                                                {
                                                                                    item.total_quick_actions
                                                                                }
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                )
                                            )}
                                    </>
                                ) : (
                                    <Card
                                        bordered={false}
                                        className='curve_card m-auto custom-scrollbar-curve'>
                                        <img src={BookMark} alt='' />
                                        <h1>No record found...</h1>
                                    </Card>
                                )}
                            </Row>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default View;
